import React, { useEffect } from 'react';
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import FormInput from '../ReactHookFormCustom/FormInput';

const QuestionModal = ({ showQuestionModal, saveJobQuestion, modalPurpose, question, onToggle }) => {
  const { t } = useTranslation();

  const { handleSubmit, reset, control } = useForm({});

  useEffect(() => {
    if (!showQuestionModal || modalPurpose === 'create') {
      reset({
        question: null,
        questionId: null,
      });
    } else {
      reset({
        question: question?.content,
        questionId: question?.id,
      });
    }
  }, [showQuestionModal, reset, question]);

  const handleSubmitWithValidations = (values) => {
    saveJobQuestion(values);
  };

  return (
    <Modal isOpen={showQuestionModal} centered>
      <ModalHeader>
        <em className="fa-2x icon-question">
          {' '}
          {modalPurpose === 'create' ? t('questions.ADD_QUESTION') : t('questions.EDIT_QUESTION')}
        </em>
      </ModalHeader>
      <form onSubmit={handleSubmit(handleSubmitWithValidations)}>
        <ModalBody>
          <Row className="pt-2">
            <Col>
              <FormInput
                control={control}
                name="question"
                id="questionId"
                label={t('questions.QUESTION')}
                rules={{ required: t('common.REQUIRED') }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <div>
            <Button color="primary">{t('common.SAVE')}</Button>
            &nbsp;
            <Button color="secondary" onClick={() => onToggle('close')}>
              {t('common.CANCEL')}
            </Button>
          </div>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default QuestionModal;
